import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSingleColumn } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import { EFFECTIVE_DATE, LAST_UPDATED, INTRO, DISCLAIMER, SECTIONS, CONTACT } from './TermsOfServicePage.content';

import css from './TermsOfServicePage.module.css';

const Block = ({ block }) => {
  if (block.h3) {
    return <h3 className={css.subheading}>{block.h3}</h3>;
  }
  if (block.list) {
    return (
      <ul className={css.list}>
        {block.list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.defList) {
    return (
      <ul className={css.list}>
        {block.defList.map((item, index) => (
          <li key={index}>
            <strong>{item.term}</strong>
            {item.text}
          </li>
        ))}
      </ul>
    );
  }
  if (block.boldLead) {
    return (
      <p>
        <strong>{block.boldLead}</strong>
        {block.p}
      </p>
    );
  }
  return <p>{block.p}</p>;
};

// This "content-only" component can be used in modals etc. (e.g. the terms
// acceptance modal shown during signup) - it no longer depends on
// Console-hosted page data, so the data-fetching props are accepted for
// backwards compatibility with existing callers but are unused.
export const TermsOfServiceContent = () => {
  return (
    <div className={css.content}>
      <h2 className={css.heading}>Terms and Conditions</h2>
      <div className={css.meta}>
        <p>{CONTACT.companyLine}</p>
        <p>
          Effective Date: {EFFECTIVE_DATE} &nbsp;|&nbsp; Last Updated: {LAST_UPDATED}
        </p>
      </div>
      <p className={css.intro}>{INTRO}</p>
      <p className={css.disclaimer}>{DISCLAIMER}</p>
      {SECTIONS.map(section => (
        <section key={section.number} className={css.section}>
          <h3 className={css.sectionHeading}>
            {section.number}. {section.title}
          </h3>
          {section.blocks.map((block, index) => (
            <Block key={index} block={block} />
          ))}
        </section>
      ))}
      <section className={css.section}>
        <h3 className={css.sectionHeading}>
          {CONTACT.number}. {CONTACT.title}
        </h3>
        <p className={css.contact}>
          {CONTACT.companyLine}
          <br />
          Address: {CONTACT.address}
          <br />
          Email: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        </p>
      </section>
    </div>
  );
};

export const TermsOfServicePageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title="Terms and Conditions" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.content}>
          <h1 className={css.heading}>Terms and Conditions</h1>
          <div className={css.meta}>
            <p>{CONTACT.companyLine}</p>
            <p>
              Website: nothingtowearclub.ca &nbsp;|&nbsp; App: Nothing To Wear Club
            </p>
            <p>
              Effective Date: {EFFECTIVE_DATE} &nbsp;|&nbsp; Last Updated: {LAST_UPDATED}
            </p>
          </div>

          <p className={css.intro}>{INTRO}</p>
          <p className={css.disclaimer}>{DISCLAIMER}</p>

          {SECTIONS.map(section => (
            <section key={section.number} className={css.section}>
              <h2 className={css.sectionHeading}>
                {section.number}. {section.title}
              </h2>
              {section.blocks.map((block, index) => (
                <Block key={index} block={block} />
              ))}
            </section>
          ))}

          <section className={css.section}>
            <h2 className={css.sectionHeading}>
              {CONTACT.number}. {CONTACT.title}
            </h2>
            <p className={css.contact}>
              {CONTACT.companyLine}
              <br />
              Address: {CONTACT.address}
              <br />
              Email: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </p>
          </section>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsOfServicePage = compose(connect(mapStateToProps))(TermsOfServicePageComponent);

export default TermsOfServicePage;
